import { SalesfloorRoom } from 'browser/components/SalesfloorRoom';
import { SalesfloorChatMessage, SalesfloorParticipant } from 'sb-lib/types';
import { VideoRoom } from 'types/video';

export type SalesfloorRoomPrivacyMode = 'private' | 'public' | 'team' | 'live_listen';

export interface CreateSalesfloorRoomRequest {
  name: string;
  privacyMode: SalesfloorRoomPrivacyMode;
  emoji: string;
  cover: string;
}

export type SalesfloorRoomParticipantStatus =
  | 'active'
  | 'inactive'
  | 'dialing'
  | 'connected';

export type SalesfloorRoomChatParticipantStatus = SalesfloorRoomParticipantStatus &
  'gone';

export interface SalesfloorRoomParticipant {
  id: string;
  displayName: string;
  lastActivity: string | null;
  status: SalesfloorRoomParticipantStatus;
  avatarUrl: string | null;
}

export type SalesfloorRoomChatParticipant = SalesfloorRoomParticipant & {
  status: SalesfloorRoomChatParticipantStatus;
};

export interface SalesfloorRoom extends CreateSalesfloorRoomRequest {
  id: string;
  ownerId: number;
  lastActivity: string | null;
  version: number;
  videoRoom: VideoRoom;
  participants: SalesfloorRoomParticipant[];
  orgId: number;
}

export function isSalesfloorRoom(x: any): x is SalesfloorRoom {
  return (
    typeof x === 'object' &&
    x !== null &&
    typeof x.id === 'string' &&
    (typeof x.lastActivity === 'string' || x.lastActivity === null) &&
    typeof x.version === 'number' &&
    typeof x.videoRoom === 'object' &&
    Array.isArray(x.participants) &&
    x.participants.every((p: any) => isSalesfloorRoomParticipant(p))
  );
}

function isSalesfloorRoomParticipant(x: any): x is SalesfloorRoomParticipant {
  return (
    typeof x === 'object' &&
    x !== null &&
    typeof x.id === 'string' &&
    typeof x.displayName === 'string' &&
    (typeof x.lastActivity === 'string' || x.lastActivity === null) &&
    ['active', 'inactive', 'dialing', 'connected'].includes(x.status) &&
    (typeof x.avatarUrl === 'string' || x.avatarUrl === null)
  );
}

export interface SalesfloorRoomJoinResponse {
  token: string;
}

export const salesfloorRoomConversationID = (room: SalesfloorRoom) => room.id;

export interface SalesfloorConversation {
  id: string;
  participants: SalesfloorRoomParticipant[];
  chatMessages: SalesfloorChatMessage[];
  isTypingState: SalesfloorTypingStateMap;
  unreadMessages: number;
}

export type SalesfloorUserConversations = {
  [key: string]: SalesfloorConversation;
};

export type TypingUpdate = {
  participant: SalesfloorParticipant;
  isTyping: boolean;
  timestamp: number;
};

export type SalesfloorTypingStateMap = {
  [key: string]: TypingUpdate;
};
